import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FieldRadio, RadioGroup} from "cstar-react-primitives";

import {cashbotName, ToggleField} from '../../../core';
import { storedPaymentMessages } from "./storedPaymentMessages";
import { useFormatMessage } from "../../../../intl/intlHooks";
import {orderSummarySSOCheckout} from "../../../orderSummary/orderSummaryMessages";
import {useUsers} from "../../../../user/UserContext";
import StoredCreditCardFormik from "./StoredPaymentForm";
import {isObjectEmpty} from "../../../../utils/sharedFunctions";
import {getCardDisplayName} from "../creditCard/creditCardUtils";

export const SAVE_PAYMENT = 'savePayment';

export const SavePaymentField = ({clickHandler}) => {
    const formatMessage = useFormatMessage();
    const label = formatMessage(storedPaymentMessages.savePaymentLabel);
    return (
        <ToggleField
            name={SAVE_PAYMENT}
            toggleClickHandler={clickHandler}
            label={label}
        />
    );
};

SavePaymentField.propTypes = {
    clickHandler: PropTypes.func.isRequired
};

export const StoredPaymentTab = (props) => {
    const {label} = props;
    return (<div>{label}</div>);
};

StoredPaymentTab.propTypes = {
  label: PropTypes.string.isRequired
};

export function generatePaymentProps(payment){
    const cardType = payment.cardType;
    const cardName = getCardDisplayName(cardType);
    
    return {
        storedPaymentUuid: payment.storedPaymentUUID,
        label: `${cardName} ••${payment.cardNumLast4}, ${payment.expMonth}/${payment.expYear}`
    };
}

export const StoredPaymentTabs = ({ children }) => {
    const formatMessage = useFormatMessage();
    const [useStoredCreditCard, setUseStoredCreditCard] = useState(true);
    const {userData} = useUsers();
    const storedPayments = !isObjectEmpty(userData) ? userData.storedPayments : [];
    const radioOptions = storedPayments ? storedPayments.map((payment) => {
        const {storedPaymentUuid, ...paymentProps} = generatePaymentProps(payment);
        return {
            value: storedPaymentUuid,
            children: (
                <StoredPaymentTab {...paymentProps} />
            )
        };
    }) : [];
    radioOptions.push(
        {
            value: 'creditCard',
            children: (<div>Use a different Card</div>)
        },
    );
    const defaultValue = radioOptions[0].value;
    const [selectedPaymentMethodValue, setSelectedPaymentMethodValue] = useState(defaultValue);

    const handleChange = value => {
        setUseStoredCreditCard(value !== 'creditCard');
        setSelectedPaymentMethodValue(value);
    };
    const hasStoredPayment = radioOptions.length > 1;

    return (hasStoredPayment ?
            (
                <div>
                    <RadioGroup
                        legend={formatMessage(orderSummarySSOCheckout.checkoutType)}
                        name="stored-payment-options"
                        cashbotName={cashbotName}
                        className="stored-payment-picker"
                    >
                        { radioOptions.map((option) => {
                                return (
                                    <FieldRadio
                                        name={option.value}
                                        key={option.value}
                                        val={option.value}
                                        isChecked={option.value === selectedPaymentMethodValue}
                                        cssClass="stored-payment-option"
                                        handleChange={handleChange}
                                        styleType="picker"
                                    >
                                        {option.children}
                                    </FieldRadio>
                                )
                            }
                        )}
                    </RadioGroup>
                    {useStoredCreditCard ? <StoredCreditCardFormik uuid={selectedPaymentMethodValue} /> : children }
                </div>
            ) : children
    );
};

StoredPaymentTabs.propTypes = {
    children: PropTypes.object.isRequired
};
